// CLOSE ALL DROPDOWNS NAVBAR
function closeNavbarDropdown() {
  const dropdowns = document.querySelectorAll('.navbar-dropdown');
  const dropdownsContent = document.querySelectorAll('.navbar-dropdown-content');
  const dropdownLinks = document.querySelectorAll('.navbar-link');
  const closeDropdownBg = document.querySelectorAll('.navbar-dropdown-close-bg');

  if(dropdowns) {
    dropdowns.forEach((dropdown) => {
      dropdown.classList.remove('d-block');
    });
  }

  if(dropdownsContent) {
    dropdownsContent.forEach((content) => {
      content.classList.remove('d-block');
    });
  }

  if(dropdownLinks) {
    dropdownLinks.forEach((link) => {
      link.classList.remove('navbar-link-active');
    });
  }

  if(closeDropdownBg) {
    closeDropdownBg.forEach((bg) => {
      bg.classList.remove('d-block');
    });
  }
}

// FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBAR MENUS
export function showNavbarDropdown(dropdown, content, index) {

  const dropdownSelected = document.querySelectorAll(dropdown);
  const containerSelected = document.querySelectorAll(content);
  const closeDropdown = document.querySelectorAll('.close-dropdown');
  const closeDropdownBg = document.querySelectorAll('.navbar-dropdown-close-bg');

  // show dropdown by clicking on navbar item
  if(dropdownSelected) {

    dropdownSelected.forEach((dropdown) => {
      
      const dropdownName = dropdown.dataset.name;
      const dropdownContent = document.querySelector(`.navbar-dropdown-content[data-name="${dropdownName}"]`);

      dropdown.addEventListener('click', () => {

        if(dropdown.classList.contains('navbar-link-active')) {
          closeNavbarDropdown();
        } else {
          closeNavbarDropdown();
          dropdown.classList.add('navbar-link-active');
          closeDropdownBg[index].classList.add('d-block');
          containerSelected[index].classList.add('d-block');
          dropdownContent.classList.add('d-block');
        }

      });

  });
    
    
    
  }

  if(closeDropdown){

    closeDropdown.forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => { 
        closeNavbarDropdown();
      })
    })

  }
}

// FUNCTION TO CONTROL DROPDOWNS ONLY IN SIDEBARS
export function showSidebarDropdown(dropSidebar, contentSidebar, indexSidebar) {
  const dropdownSelected = document.querySelector(dropSidebar);
  const contentSelected = document.querySelectorAll(contentSidebar);

  if(dropdownSelected) {
  

    dropdownSelected.addEventListener('click', () => {

      contentSelected[indexSidebar].classList.toggle('d-flex');

      if(contentSelected[indexSidebar].classList.contains('d-flex')) {
        const dropdownHeight = contentSelected[indexSidebar].offsetHeight;

        dropdownSelected.style.cssText = `margin-bottom: calc(${dropdownHeight}px + 10px);`;
      } else {
        dropdownSelected.style.removeProperty('margin-bottom');
      }
    });
  }
}
